import { Box, Skeleton, Stack, useMediaQuery } from '@chakra-ui/react';

export const RecipeFavoriteSkeleton = () => {
  const [isMobile] = useMediaQuery('(max-width: 992px)');
  return isMobile ? (
    <Stack spacing="6">
      <Stack spacing="2">
        <Skeleton h="136px" w="full" rounded="xl" />
        <Skeleton h="136px" w="full" rounded="xl" />
      </Stack>
      <Box
        display="grid"
        gridTemplateColumns="repeat(3, 1fr)"
        columnGap="3"
        rowGap="6"
      >
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} h="135px" w="full" rounded="xl" />
        ))}
      </Box>
    </Stack>
  ) : (
    <Box
      display="grid"
      gridTemplateColumns="repeat(3, 1fr)"
      columnGap="8"
      rowGap="6"
    >
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton key={index} h="160px" w="full" rounded="xl" />
      ))}
    </Box>
  );
};
